import * as graphql from 'generated/graphql';
import {
  currencyAndDecimalFieldPolicy,
  dateTimeFieldPolicy
} from './fieldPolicies';
import { ITypeSpecificPolicy } from './shared';



export const CompanyStatistics: ITypeSpecificPolicy<graphql.CompanyStatistics> = {
  fields: {
    dividendYield: currencyAndDecimalFieldPolicy(),
    firstTradingDate: dateTimeFieldPolicy(),
    nextEarningsReportDate: dateTimeFieldPolicy(),
    averageDailyTradingVolumeMill: currencyAndDecimalFieldPolicy(),
    volume: currencyAndDecimalFieldPolicy(),
    basicSharesOutStandingMill: currencyAndDecimalFieldPolicy()
  }
};
